import { createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    paymentTrackRangeRequest: ['businessId', 'startDate', 'endDate', 'options'],
    collectedPaymentTrackRequest: ["businessId", "filter", "options"],
    missedPaymentTrackRequest: ["businessId", "filter", "options"],
    externalPaymentTrackRequest: ["businessId", "filter", "options"],
    accountsPaymentSearchRequest: ["businessId", "filter", "options"],
    accountsPaymentCsvRequest: ["businessId", "query", "options"],
    accountsPaymentPdfRequest: ["businessId", "membershipId", "query", "options"],
    paymentTracksCsvRequest: ["businessId", "membershipId", "query", "options"],
    paymentTracksPdfRequest: ["businessId", "membershipId", "query", "options"],
    accountsPaymentTotalsRequest: ["businessId", "query", "options"],
    paymentAttributionsRequest: ["paymentTrackId"],
    filteredDataTotalsRequest: ["businessId", "filter", "options"],
    planPaymentSummaryRequest: ["businessId", "startDate", "endDate"],
    planReconciliationSummaryRequest: ["businessId", "startDate", "endDate"],
    externalColleagueSummaryRequest: ["businessId", "startDate", "endDate", "membershipId"],
    externalColleagueSummaryCsvRequest: ["businessId", "startDate", "endDate", "membershipId"],
    externalColleagueSummaryPdfRequest: ["businessId", "membershipId", "startDate", "endDate", "recordedById"],
    paymentTracksSummaryPdfRequest: ["businessId", "membershipId", "startDate", "endDate"],
    paymentTracksReconciliationPdfRequest: ["businessId", "membershipId", "startDate", "endDate"],

    paymentTrackRangeSuccess: ['paymentTrackRange'],
    collectedPaymentTrackSuccess: ["paymentTrack"],
    missedPaymentTrackSuccess: ["paymentTrack"],
    externalPaymentTrackSuccess: ["paymentTrack"],
    accountsPaymentSearchSuccess: ["accountsPaymentSearch"],
    accountsPaymentCsvSuccess: ["accountsPaymentCsv"],
    accountsPaymentPdfSuccess: ["accountsPaymentPdf"],
    paymentTracksCsvSuccess: ["csv"],
    paymentTracksPdfSuccess: ["pdf"],
    accountsPaymentTotalsSuccess: ["accountsPaymentTotals"],
    paymentAttributionsSuccess: ["paymentAttributions"],
    filteredDataTotalsSuccess: ["data"],
    planPaymentSummarySuccess: ["planPaymentSummary"],
    planReconciliationSummarySuccess: ["planReconciliationSummary"],
    externalColleagueSummarySuccess: ["externalColleagueSummary"],
    externalColleagueSummaryCsvSuccess: ["csv"],
    externalColleagueSummaryPdfSuccess: ["pdf"],
    paymentTracksSummaryPdfSuccess: ["pdf"],
    paymentTracksReconciliationPdfSuccess: ["pdf"],


    paymentTrackRangeFailure: ['error'],
    collectedPaymentTrackFailure: ["error"],
    missedPaymentTrackFailure: ["error"],
    externalPaymentTrackFailure: ["error"],
    accountsPaymentSearchFailure: ["error"],
    accountsPaymentCsvFailure: ["error"],
    accountsPaymentPdfFailure: ["error"],
    paymentTracksCsvFailure: ["error"],
    paymentTracksPdfFailure: ["error"],
    accountsPaymentTotalsFailure: ["error"],
    paymentAttributionsFailure: ["error"],
    filteredDataTotalsFailure: ["error"],
    planPaymentSummaryFailure: ["error"],
    planReconciliationSummaryFailure: ["error"],
    externalColleagueSummaryFailure: ["error"],
    externalColleagueSummaryCsvFailure: ["error"],
    externalColleagueSummaryPdfFailure: ["error"],
    paymentTracksSummaryPdfFailure: ["error"],
    paymentTracksReconciliationPdfFailure: ["error"],
})

export const PaymentTrackTypes = Types
export default Creators